/*
 * @Author: 孙培国
 * @Date: 2024-08-17 16:47:30
 * @LastEditors: Do not edit
 * @LastEditTime: 2024-08-26 13:53:48
 * @FilePath: \vue2-vant2-rem-h5-template\src\config\env.production.js
 */
// 本地环境配置
module.exports = {
  title: '赛事',
  englishName:'H5 Template System',
  version: 'V1.0.0',
  technicalSupport: '',
  copyright: 'Copyright @ 2023  ',
  // baseUrl: 'https://wz.zhenkelife.com/api', // 项目地址.
  baseUrl: 'https://wz.zhenkelife.com', // 项目地址
  baseApi: '/', // 本地api请求地址,注意：如果你使用了代理，请设置成'/'
  corpId: '钉钉id'
}